import { Navigate, Outlet } from 'react-router';
import {
  isModuleEnabled,
  type ModuleKey,
} from '@bill-alps/backend/features/companies/modules';
import { useCurrentUser } from '@/hooks/use-current-user';
import { MODULE_AVAILABLE } from '@/lib/runtime/feature-flags';
import { PageLoader } from './page-loader';

export function ModuleGate({ module }: { module: ModuleKey }) {
  const { user, isLoading, canReadModule } = useCurrentUser();

  if (!MODULE_AVAILABLE[module]) {
    return <Navigate to="/dashboard" replace />;
  }

  if (isLoading) {
    return <PageLoader />;
  }

  if (!isModuleEnabled(user?.company, module) || !canReadModule(module)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
